// extracted by mini-css-extract-plugin
export default {"chart-type-selector":"M_dL"};